import newShop from '../newShop.js';

newShop.Payment = function(paymentData){
    "use strict";

    if (paymentData && paymentData !== null){
        this.bePaymentTypeId = paymentData.bePaymentTypeId;
        this.paymentName = paymentData.paymentName;
        this.paymentTypeId = paymentData.paymentTypeId;
        this.paymentTypeDescription = paymentData.paymentTypeDescription;
        this.paymentNumber = paymentData.paymentNumber;
        this.ccToken = paymentData.ccToken;
        this.paymentSecurityNumber = paymentData.paymentSecurityNumber;
        this.expMonth = paymentData.expMonth;
        this.expYear = paymentData.expYear;
        this.paymentPostalCode = paymentData.paymentPostalCode;
        this.address1 = paymentData.address1;
        this.address2 = paymentData.address2;
        this.city = paymentData.city;
        this.region = paymentData.region;
        this.email = paymentData.email;
        this.phone = paymentData.phone;
        this.defaultPayment = paymentData.defaultPayment;
        this.amount = paymentData.amount;
        this.billingName = paymentData.billingName;
        this.billingAddress = paymentData.billingAddress;
        this.billingCity = paymentData.billingCity;
        this.billingState = paymentData.billingState;
        this.billingPostalCode = paymentData.billingPostalCode;
        this.billingCountry = paymentData.billingCountry;
        this.billingPhone = paymentData.billingPhone;
        this.billingEmail = paymentData.billingEmail;
        this.savePayment = paymentData.savePayment;
        this.unsavedPayment = paymentData.unsavedPayment;
        this.sapPaymentId = paymentData.sapPaymentId;
        this.useInstallments = false;
        this.installmentsAllowed = false;
        this.installmentSelectedNumber = 0;
        this.availableInstallmentPeriods = [];
        this.countryCode = paymentData.countryCode;
        this.useInstallments = paymentData.useInstallments;
        this.installmentsAllowed = paymentData.installmentsAllowed;
        this.minimumInstallmentAmount = paymentData.minimumInstallmentAmount;
        this.installmentSelectedNumber = paymentData.installmentSelectedNumber;
        this.availableInstallmentPeriods = paymentData.availableInstallmentPeriods;
        this.mandateType = paymentData.mandateType;

        // Columbia Fields
        this.extTerm = paymentData.extTerm;
        this.transNumber = paymentData.transNumber;
        this.codDeRta = paymentData.codDeRta;
        this.merchTxRef = paymentData.merchTxRef;
        this.authorizationCode = paymentData.authorizationCode;
    }

    this.applyShippingAddress = function(address) {
        let hasValidAddress = address && address.toJSON,
            data;

        // Address supports 'toJSON' so go ahead and get the data
        if (hasValidAddress) {
            data = address.toJSON();

        // If address doesn't have 'toJSON', but seems to have all the
        // properties exposed already
        } else if (address && address.shippingAddress1) {
            data = address;
            hasValidAddress = true;
        }

        if(data && hasValidAddress) {
            this.paymentPostalCode    = data.shippingPostalCode;
            this.address2             = data.shippingAddress2;
            this.city                 = data.shippingCity;
            this.countryCode          = data.shippingCountry;

            this.billingState         = this.region         = data.shippingState;
            this.address1             = this.billingAddress = data.shippingAddress1;
            //Only copy the first 25 characters because the max-length of the billingName is 25.
            this.billingName          = this.paymentName    = data.shippingAddressName.slice(0,25);

            this.billingCity          = data.shippingCity;
            this.billingPostalCode    = data.shippingPostalCode;
            this.billingCountry       = data.shippingCountry;
            this.billingPhone         = this.phone          = data.shippingPhone;
            this.billingEmail         = this.email          = data.shippingEmail;

            // For es_CO and similar markets
            this.antiFraudBillingAddress  = this.address1;
            this.antiFraudBillingCity     = this.billingCity;
            this.antiFraudBillingCountry  = this.billingCountry;

            return true;

        } else {

            console.log("Could not copy address. Was invalid, or did not support 'toJSON'.");
            console.log("Shipping address: ", address);
            return false;
        }
    };

    this.toJSON = function(){
        let payment = {};
        payment.bePaymentTypeId = this.bePaymentTypeId;
        payment.paymentName = this.paymentName;
        payment.paymentTypeId = this.paymentTypeId;
        payment.paymentTypeDescription = this.paymentTypeDescription;
        payment.paymentNumber = this.paymentNumber;
        payment.ccToken = this.ccToken;
        payment.paymentSecurityNumber = this.paymentSecurityNumber;
        payment.shippingCounty = this.shippingCounty;
        payment.expMonth = this.expMonth;
        payment.shippingPostalCode = this.shippingPostalCode;
        payment.shippingCountry = this.shippingCountry;
        payment.expYear = this.expYear;
        payment.paymentPostalCode = this.paymentPostalCode;
        payment.address1 = this.address1;
        payment.address2 = this.address2;
        payment.city = this.city;
        payment.region = this.region;
        payment.phone  = this.phone;
        payment.email  = this.email;
        payment.defaultPayment = this.defaultPayment;
        payment.amount = this.amount;
        payment.billingName = this.billingName;
        payment.billingAddress = this.billingAddress;
        payment.billingCity = this.billingCity;
        payment.billingState = this.billingState;
        payment.billingPostalCode = this.billingPostalCode;
        payment.billingCountry = this.billingCountry;
        payment.billingPhone = this.billingPhone;
        payment.billingEmail = this.billingEmail;
        payment.savePayment = this.savePayment;
        payment.unsavedPayment = this.unsavedPayment;
        payment.sapPaymentId = this.sapPaymentId;
        payment.useInstallments = this.useInstallments;
        payment.installmentsAllowed = this.installmentsAllowed;
        payment.minimumInstallmentAmount = this.minimumInstallmentAmount;
        payment.installmentSelectedNumber = this.installmentSelectedNumber;
        payment.availableInstallmentPeriods = this.availableInstallmentPeriods;
        payment.countryCode = this.countryCode;
        payment.mandateType = this.mandateType;

        // Columbia Fields
        payment.extTerm = this.extTerm;
        payment.transNumber = this.transNumber;
        payment.codDeRta = this.codDeRta;
        payment.merchTxRef = this.merchTxRef;
        payment.authorizationCode = this.authorizationCode;

        return payment;
    };

    // ---------------------------------------------
    //
    //        Define all setter methods.
    //
    // ---------------------------------------------
    this.setBePaymentTypeId  = function(newBePaymentTypeId) {
        this.bePaymentTypeId  = newBePaymentTypeId;
    };
    this.setPaymentName = function(newPaymentName) {
        this.paymentName = newPaymentName;
    };
    this.setPaymentTypeId = function(newPaymentTypeId) {
        this.paymentTypeId = newPaymentTypeId;
    };
    this.setPaymentTypeDescription = function(newPaymentTypeDescription) {
        this.paymentTypeDescription = newPaymentTypeDescription;
    };
    this.setPaymentNumber = function(newPaymentNumber) {
        this.paymentNumber = newPaymentNumber;
    };
    this.setCcToken = function(newCCToken) {
        this.ccToken = newCCToken;
    }
    this.setPaymentSecurityNumber = function(newPaymentSecurityNumber) {
        this.paymentSecurityNumber = newPaymentSecurityNumber;
    };
    this.setShippingCounty = function(newShippingCounty) {
        this.shippingCounty = newShippingCounty;
    };
    this.setExpMonth = function(newExpMonth) {
        this.expMonth = newExpMonth;
    };
    this.setShippingPostalCode = function(newShippingPostalCode) {
        this.shippingPostalCode = newShippingPostalCode;
    };
    this.setShippingCountry = function(newShippingCountry) {
        this.shippingCountry = newShippingCountry;
    };
    this.setExpYear = function(newExpYear) {
        this.expYear = newExpYear;
    };
    this.setPaymentPostalCode = function(newPaymentPostalCode) {
        this.paymentPostalCode = newPaymentPostalCode;
    };
    this.setAddress1 = function(newAddress1) {
        this.address1 = newAddress1;
    };
    this.setAddress2 = function(newAddress2) {
        this.address2 = newAddress2;
    };
    this.setCity = function(newCity) {
        this.city = newCity;
    };
    this.setRegion = function(newRegion) {
        this.region = newRegion;
    };
    this.setEmail = function(newEmail) {
        this.email = newEmail;
    };
    this.setPhone = function(newPhone) {
        this.phone = newPhone;
    };
    this.setDefaultPayment = function(newDefaultPayment) {
        this.defaultPayment = newDefaultPayment;
    };
    this.setAmount = function(newAmount) {
        this.amount = newAmount;
    };
    this.setBillingName = function(newBillingName) {
        this.billingName = newBillingName;
    };
    this.setBillingAddress = function(newBillingAddress) {
        this.billingAddress = newBillingAddress;
    };
    this.setBillingCity = function(newBillingCity) {
        this.billingCity = newBillingCity;
    };
    this.setBillingState = function(newBillingState) {
        this.billingState = newBillingState;
    };
    this.setBillingPostalCode = function(newBillingPostalCode) {
        this.billingPostalCode = newBillingPostalCode;
    };
    this.setBillingCountry = function(newBillingCountry) {
        this.billingCountry = newBillingCountry;
    };
    this.setBillingPhone = function(newBillingPhone) {
        this.billingPhone = newBillingPhone;
    };
    this.setBillingEmail = function(newBillingEmail) {
        this.billingEmail = newBillingEmail;
    };
    this.setSavePayment = function(newSavePayment) {
        this.savePayment = newSavePayment;
    };
    this.setUnsavedPayment = function(newUnsavedPayment) {
        this.unsavedPayment = newUnsavedPayment;
    };
    this.setSapPaymentId = function(newSapPaymentId) {
        this.sapPaymentId = newSapPaymentId;
    };
    this.setUseInstallments  = function(newUseInstallments) {
        this.useInstallments  = newUseInstallments;
    };
    this.setMinimumInstallmentAmount  = function(newMinimumInstallmentAmount) {
        this.minimumInstallmentAmount  = newMinimumInstallmentAmount;
    };
    this.setInstallmentSelectedNumber  = function(newInstallmentSelectedNumber) {
        this.installmentSelectedNumber  = newInstallmentSelectedNumber;
    };
    this.setInstallmentsAllowed  = function(newInstallmentsAllowed) {
        this.installmentsAllowed  = newInstallmentsAllowed;
    };
    this.setAvailableInstallmentPeriods  = function(newAvailableInstallmentPeriods) {
        this.availableInstallmentPeriods  = newAvailableInstallmentPeriods;
    };
    this.setCountryCode  = function(newCountryCode) {
        this.countryCode  = newCountryCode;
    };
    this.setMandateType  = function(newMandateType) {
        this.mandateType  = newMandateType;
    };

    // ---------------------------------------------
    //
    //        Define all getter methods.
    //
    // ---------------------------------------------
    this.getBePaymentTypeId = function(/*newBePaymentTypeId*/) {
        return this.bePaymentTypeId;
    };
    this.getPaymentName = function() {
        return this.paymentName;
    };
    this.getPaymentTypeId = function() {
        return this.paymentTypeId;
    };
    this.getPaymentTypeDescription = function() {
        return this.paymentTypeDescription;
    };
    this.getPaymentNumber = function() {
        return this.paymentNumber;
    };
    this.getCcToken = function() {
        return this.ccToken;
    }
    this.getPaymentSecurityNumber = function() {
        return this.paymentSecurityNumber;
    };
    this.getExpMonth = function() {
        return this.expMonth;
    };
    this.getExpYear = function() {
        return this.expYear;
    };
    this.getPaymentPostalCode = function() {
        return this.paymentPostalCode;
    };
    this.getAddress1 = function() {
        return this.address1;
    };
    this.getAddress2 = function() {
        return this.address2;
    };
    this.getCity = function() {
        return this.city;
    };
    this.getRegion = function() {
        return this.region;
    };
    this.getEmail = function() {
        return this.email;
    };
    this.getPhone = function() {
        return this.phone;
    };
    this.getDefaultPayment = function() {
        return this.defaultPayment;
    };
    this.getAmount = function() {
        return this.amount;
    };
    this.getBillingName = function() {
        return this.billingName;
    };
    this.getBillingAddress = function() {
        return this.billingAddress;
    };
    this.getBillingCity = function() {
        return this.billingCity;
    };
    this.getBillingState = function() {
        return this.billingState;
    };
    this.getBillingPostalCode = function() {
        return this.billingPostalCode;
    };
    this.getBillingCountry = function() {
        return this.billingCountry;
    };
    this.getBillingPhone = function() {
        return this.billingPhone;
    };
    this.getBillingEmail = function() {
        return this.billingEmail;
    };
    this.getSavePayment = function() {
        return this.savePayment;
    };
    this.getUnsavedPayment = function() {
        return this.unsavedPayment;
    };
    this.getSapPaymentId = function() {
        return this.sapPaymentId;
    };
    this.getUseInstallments  = function() {
        return this.useInstallments;
    };
    this.getMinimumInstallmentAmount  = function() {
        return this.minimumInstallmentAmount;
    };
    this.getInstallmentSelectedNumber  = function() {
        let installmentSelectedNumber = 1;
        if (this.installmentSelectedNumber){
            installmentSelectedNumber = this.installmentSelectedNumber;
        }
        return installmentSelectedNumber;
    };
    this.getInstallmentsAllowed  = function() {
        return this.installmentsAllowed;
    };
    this.getAvailableInstallmentPeriods  = function() {
        return this.availableInstallmentPeriods;
    };
    this.getCountryCode  = function() {
        return this.countryCode;
    };
    this.getMandateType  = function() {
        return this.mandateType;
    };

};

export default newShop.Payment;
